import { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable, Loading } from '../../components';
import { ProfileContext } from '../../contexts';
import { CommonService, MenteeService } from '../../services';
import { registerView } from '../../helpers';
import { ApplicationStatusFilter } from '../../components/DataTable/filters';
import { fetchMenteeRecords } from '../../helpers';

export function MenteeDashboard() {
  const navigate = useNavigate();
  const { profile } = useContext(ProfileContext);
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (typeof profile?.deadline?.isDeadlineOver !== 'boolean') return;
    if (profile?.nar_membership_type !== 'S') {
      registerView(profile, 'Unauthorized');
      navigate('/');
      return;
    }
    MenteeService.getQuestions()
      .then((questions) => setQuestions(questions))
      .catch(console.error);
    registerView(profile);
  }, [profile?.deadline?.isDeadlineOver]);

  const columnsConfig = useMemo(() => {
    const appStatus = questions.filter(
      (question) => question.QuestionType === 'Admin Dropdown'
    );
    return [
      {
        header: () => <span>State/Province</span>,
        accessorKey: '19',
        accessorFn: (originalRow) => {
          if (originalRow?.[19]?.value) {
            return originalRow[19]?.value;
          } else {
            return '';
          }
        },
      },
      {
        header: () => <span>First Name</span>,
        accessorKey: '12',
        accessorFn: (originalRow) => {
          if (originalRow?.[12]?.value) {
            return originalRow[12]?.value;
          } else {
            return '';
          }
        },
      },
      {
        header: () => <span>Last Name</span>,
        accessorKey: '13',
        accessorFn: (originalRow) => {
          if (originalRow?.[13]?.value) {
            return originalRow[13]?.value;
          } else {
            return '';
          }
        },
      },
      {
        header: () => <span>Local Association</span>,
        accessorKey: '61',
        accessorFn: (originalRow) => {
          if (originalRow?.[61]?.value) {
            return originalRow[61].value;
          } else {
            return '';
          }
        },
      },
      {
        header: () => <span>Application Status</span>,
        accessorKey: '67',
        accessorFn: (originalRow) => {
          if (originalRow?.[67]?.value) {
            return originalRow[67]?.value;
          } else {
            return '';
          }
        },
        filterComponent: ({ column }) => (
          <ApplicationStatusFilter
            column={column}
            options={appStatus?.[0]?.QuestionOptions}
          />
        ),
      },
      {
        header: () => <span>Submission Date</span>,
        accessorKey: 'Created',
        cell: ({ getValue }) => <span>{getValue()?.split?.('T')?.[0]}</span>,
      },
    ];
  }, [
    questions.filter(
      (question) => question.QuestionType === 'Admin Dropdown'
    )[0]?.QuestionDescription,
  ]);

  function onRowClick({ data, id }) {
    const answers = {};
    Object.entries(data[id]).forEach(([k, v]) => {
      if (typeof v !== 'string') {
        answers[k] = v;
      }
    });
    navigate('/admin/mentee/review', { state: answers });
  }

  if (!profile?.email) {
    return (
      <div className="App-content App-loading-content">
        <Loading />
      </div>
    );
  }
  return (
    <div className="App-content">
      <DataTable
        onRowClick={onRowClick}
        fetchRecords={fetchMenteeRecords}
        queryKey="mentees"
        exportRecords
        getQuestions={MenteeService.getQuestions}
        columnsConfig={columnsConfig}
      />
    </div>
  );
}
